import { FC, HTMLAttributes } from 'react';
import { merge } from '../../helpers/Utility';

export enum SizerMode {
  FULL,
  CONTENT,
  HEADER,
  PAGE
}

interface PageSizerProps extends HTMLAttributes<HTMLDivElement> {
  mode?: SizerMode;
}

export const PageSizer: FC<PageSizerProps> = ({ mode, children, className, ...props }) => {
  let classToApply = merge('w-full', className);

  if (mode !== SizerMode.FULL) {
    classToApply = merge('max-w-7xl mx-auto sm:px-4 lg:px-8', classToApply);
  } else {
    classToApply = merge('py-4 px-20', classToApply);
  }

  if (mode === SizerMode.HEADER || mode === SizerMode.PAGE) {
    classToApply = merge('py-4 px-4', classToApply);
  }

  if (mode === SizerMode.PAGE) {
    classToApply = merge('lg:py-8', classToApply);
  }

  return (
    <div {...props} className={classToApply}>
      {children}
    </div>
  );
};
